import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpTestService } from '../../services/http.service';

@Component({
  selector: 'app-solar-pv',
  templateUrl: './solar-pv.component.html',
  styleUrls: ['./solar-pv.component.css']
})
export class SolarPvComponent implements OnInit {

  successMsg: string ="";
  errorMsg: string ="";

  currentDate:any;
  zone:any=null;//mandatory
  consumerID:any=null;
  phase:any=null;//mandatory
  contractDemand:any=0;//mandatory
  name:any="";//mandatory
  represent:any=null;
  address:any="";//mandatory
  mobile:any=0;//mandatory,validation
  email:any=null;
  adhar:any=0;
  kwp:any=0;
  kw:any=0;
  meter:any=null;//mandatory
  installTest:any=null;//mandatory

  hitAPI:boolean=false;
  serviceOn:boolean=false;
  spinner:boolean=false;

  constructor(public http: HttpTestService,private datepipe: DatePipe) { }

  ngOnInit() {
    this.currentDate = this.datepipe.transform(new Date(), 'dd-MM-yyyy');
  }

  submit(){
    if((this.zone==null || this.zone.trim().length==0)|| (this.phase==null || this.phase.trim().length==0) || this.contractDemand==0
       || this.name.trim().length==0 || this.address.trim().length==0 || this.mobile==0
       || (this.meter==null || this.meter.trim().length==0) || (this.installTest==null || this.installTest.trim().length==0)){
        this.errorMsg = "mandatory field(s) are blank";
        this.successMsg = "";
        this.hitAPI = false;
        return false;
    }else{
      this.successMsg = "";
      this.errorMsg = "";
      this.hitAPI = true;
    }

    if(this.contractDemand.toString().length > 5){
      this.errorMsg = "invalid contract demand"
      this.successMsg = "";
      this.hitAPI = false;
      return false;
    }else{
      this.successMsg = "";
      this.errorMsg = "";
      this.hitAPI = true;
    }

    if(this.mobile.toString().length != 10){
      this.errorMsg = "invalid mobile number"
      this.successMsg = "";
      this.hitAPI = false;
      return false;
    }else{
      this.successMsg = "";
      this.errorMsg = "";
      this.hitAPI = true;
    }

    if((this.adhar && this.adhar.toString().length > 12) || (this.kwp && this.kwp.toString().length >10)
        || (this.kw && this.kw.toString().length>10)){
          this.errorMsg = "invalid adhar or KW or KWp"
          this.hitAPI = false
          return false
    }else{
      this.errorMsg = ""
      this.hitAPI = true
    }

    if(this.hitAPI){
      let str = this.camelize(this.name)
      let param = {
        "zone" : this.zone,
        "consumerID" : this.consumerID,
        "phase" : this.phase,
        "contractDemand" :this.contractDemand,
        "name" :str,
        "represent" :this.represent,
        "address" :this.address,
        "mobile" :this.mobile,
        "email":this.email,
        "adhar" :this.adhar,
        "kwp" :this.kwp,
        "kw" :this.kw,
        "meter" :this.meter,
        "installTest" :this.installTest
      }

      this.serviceOn = true
      this.http.solarInfo(param).subscribe((result:any) => {
          if(result.responseStatus == 1){
            this.successMsg = result.responseMessage;
            this.resetForm();
          }else{
            this.errorMsg = result.responseMessage;
          }
        }, (error:any) => {
          this.errorMsg = error;
        },() => {
          this.serviceOn = false
      });
    }
  }

  resetForm(){
    this.zone = ""
    this.consumerID = ""
    this.phase = ""
    this.contractDemand = 0
    this.name = ""
    this.represent = ""
    this.address = ""
    this.mobile = 0
    this.email = ""
    this.adhar = 0
    this.kwp = 0
    this.kw = 0
    this.meter = ""
    this.installTest = ""
  }

  // submit(){
  //   let str = this.camelize(this.name)
  // }

  camelize(str) {
    str = str.trim()
    let temp = ''
    for(let i=0;i<str.length;i++){
      if(i==0)
        temp += str[i].toUpperCase()
      if(i>0 && str[i]!=' ' && str[i-1]!=' ')
        temp += str[i].toLowerCase()
      if(str[i]==' '){
        temp += str[i]
        temp += str[i+1].toUpperCase()
      }  
    }

    return temp;
  }

  viewGuide() {
    this.errorMsg = "";
    // this.http.solarGuide().subscribe(res => {
    //   var mediaType = 'application/pdf';
    //   var blob = new Blob([res], { type: mediaType });
    //   var fileURL = URL.createObjectURL(blob);
    //   window.open(fileURL);
    // }, errMsg => {
    //   this.errorMsg = errMsg;
    // });

      this.http.solarGuide()
      .subscribe(
        (response: any) => {
          const blob = response.blob();
          var fileURL = URL.createObjectURL(blob);
          window.open(fileURL);
        },(error:any) => {
          // alert('The file is not available');
          this.errorMsg = error;
        });
  }

  downloadForm(){
    this.errorMsg = "";

    this.http.solarPVform()
    .subscribe(
      (response: any) => {
        const blob = response.blob();
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      },(error:any) => {
        // alert('The file is not available');
        this.errorMsg = error;
      });
  }
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/solar-pv/solar-pv.component.ts